import { Agreement } from 'store/agreements/interfaces';
import BACKEND_AMOUNT_MODIFIER from 'config/backendAmountModifier';
import getAmountMaskFormat from 'helpers/getAmountMaskFormat';
import { minutesInHour } from 'helpers/timeConsts';

export default function getInitFormValues(agreement: Agreement) {
  return {
    position: agreement.position,
    amount: getAmountMaskFormat(agreement.amount / BACKEND_AMOUNT_MODIFIER),
    currency: agreement.currency,
    hoursPerWeek: Math.floor(agreement.minutesPerWeek / minutesInHour).toString(),
    minutesPerWeek:
      agreement.minutesPerWeek % minutesInHour === 0
        ? ''
        : (agreement.minutesPerWeek % minutesInHour).toString(),
    jobSizeHours: Math.floor(agreement.jobSize / minutesInHour).toString(),
    jobSizeMinutes:
      agreement.jobSize % minutesInHour === 0
        ? ''
        : (agreement.jobSize % minutesInHour).toString(),
    billingType: agreement.billingType,
    amountType: agreement.amountType,
    type: agreement.type,
  };
}
